import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
/**
 * Constructs a query key for @tanstack/react-query with a prefixed namespace.
 * This avoids queryKey conflicts for a shared queryClient between multiple applications
 *
 * @param {Array} queryKey - The base query key or keys to be used in react-query.
 * @returns {Array} The complete query key array with namespaced queryKey as the first element.
 */

var makeQueryKey = function makeQueryKey(queryKey) {
  return ['@shop-apis'].concat(_toConsumableArray(queryKey));
};
export default makeQueryKey;